import useTranslation from 'providers/i18n/hooks/useTranslation';
import { AuthFormProps } from '../../types';
import { UseAuthProps } from '../types';

const useAuthProps = ({ handleSubmitRegister, handleBootLogin, handleOnClosePopup }: UseAuthProps) => {
  const { translate } = useTranslation();

  const authLayoutProps: { [key in 'register']: AuthFormProps } = {
    register: {
      resetCallback: () => { },
      title: translate('account.account.register.new'),
      headTitle: translate('account.account.login.signup'),
      subtitle: translate('account.account.alreadyHave'),
      subtitleLink: '#',
      subtitleLinkClickEvent: handleBootLogin,
      subtitleLinkLabel: translate('account.sign.in'),
      buttonLabel: translate('account.account.register.continue'),
      onSubmit: handleSubmitRegister,
      onClose: handleOnClosePopup
    }
  };

  return authLayoutProps['register'];
};

export default useAuthProps;